var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100 justify-center align-center",class:_vm.$vuetify.breakpoint.xsOnly ? '' : 'pa-3'},[_vm._v(" asdas ")])}
var staticRenderFns = []

export { render, staticRenderFns }